module.exports = __webpack_public_path__ + "Roboto-Bold.woff2";